import get from 'lodash/get'
import { GET_CURRENT_SHIP } from './../constants/actionTypes'
import {
  saveActiveShipToStorage,
  clearActiveVoyageFromStorage
} from '../helpers/util'

export const getShip = data => (dispatch, getState) => {
  const currentShip = get(getState(), 'ship', '')
  if (currentShip && currentShip !== data) {
    clearActiveVoyageFromStorage(currentShip)
  }
  saveActiveShipToStorage(data)
  dispatch({
    type: GET_CURRENT_SHIP,
    data
  })
}
